import React, { useCallback, useEffect, useState } from 'react';
import OtpInput from 'react-code-input';
import { OtpVerificationModalProps } from './types';

import Modal from '../Modal/Modal';
import './OtpVerificationModal.scss';
import { useSendOtpMutation, useVerifyOtpMutation } from 'redux/services/auth';
import toast from 'react-hot-toast';
import { Loader } from '../Loader';
import { useTranslation } from 'react-i18next';

export const OtpVerificationModal: React.FC<OtpVerificationModalProps> =
  React.memo(({ open, type, value, onHide, onSubmit }) => {
    const { t } = useTranslation();
    const [otp, setOtp] = useState('');
    const [otpRender, setOtpRender] = useState(true);
    const [sessionId, setSessionId] = useState('');
    const [otpSend, setOtpSend] = useState(false);
    const [sendOtp] = useSendOtpMutation();
    const [verifyOtp] = useVerifyOtpMutation();

    const handleSendOtp = async () => {
      setOtp('');
      setOtpRender(false);
      const res: any = await sendOtp({
        mode: type,
        value,
      });
      setOtpRender(true);
      if (res.data) {
        toast.success(t('otp_sent_to_type', { type }));
        setSessionId(res.data.sessionId ?? '');
      } else {
        toast.error(res.error?.data?.message);
      }
    };

    const sendOtpCode = useCallback(async () => {
      const res: any = await sendOtp({
        mode: type,
        value,
      });
      if (res.data) {
        toast.success(t('otp_sent_to_type', { type }));
        setSessionId(res.data.sessionId ?? '');
      } else {
        toast.error(res.error?.data?.message);
        onHide();
      }
    }, [onHide, sendOtp, type, value, t]);

    useEffect(() => {
      if (open && !otpSend) {
        sendOtpCode();
        setOtpSend(true);
      }
    }, [open, otpSend, sendOtpCode]);

    useEffect(() => {
      return () => {
        setOtp('');
        setSessionId('');
      };
    }, []);

    const handleSubmit = () => {
      const verifyOtpCode = async () => {
        const res: any = await verifyOtp({
          mode: type,
          otp: Number(otp),
          value,
          sessionId,
        });

        if (res.data?.success) {
          toast.success(t('otp_verification_success'));
          onSubmit({
            otp,
            mode: type,
            verified: true,
          });
        } else {
          toast.error(t('otp_verification_error'));
        }
      };

      verifyOtpCode();
    };
    const handleOtpChange = (otp: string) => setOtp(otp);

    return (
      <Modal
        show={open}
        title=""
        withIcon
        modalClassName="otp-modal"
        modalBodyClassName="opt-verification-modal"
        submitBtnText={t('btn_verify')}
        cancelBtnText={t('resend_otp')}
        withIconBodyText={`${t('verify_your')} ${
          type === 'email' ? t('email') : t('mobile')
        }`}
        type="success"
        footerContentAlignment="right"
        submitDisabled={otp.length < 5}
        hideCancelBtn
        onSubmit={handleSubmit}
        onClose={onHide}
        onCancel={handleSendOtp}
        onBackDropClick={onHide}
      >
        <span className="description">{t('check_otp')}</span>
        <form className="px-2 py-2 w-100 position-relative">
          {otpRender ? (
            <>
              <OtpInput
                fields={6}
                name="otp"
                value={otp}
                className="verification__otp-input w-100 mb-3 d-flex justify-content-between flex-nowrap"
                type="number"
                inputMode="numeric"
                onChange={handleOtpChange}
              />
              <i className="hint">{t('verification_code_validity')}</i>
            </>
          ) : (
            <Loader />
          )}
        </form>
      </Modal>
    );
  });
